/* 🤖 this file was generated by svg-to-ts */
export const iconAfdusd: {
  name: 'afdusd';
  data: string;
} = {
  name: 'afdusd',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><circle cx="16" cy="16" r="15" stroke="currentColor" stroke-width="2"/><g clip-path="url(#afdusd__circleClip)"><g style="transform:scale(.8125);transform-origin:50% 50%"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m1.92 24.34H8.63v-4.28h9.29zm5.46-12.83h-5.45v2.35h5.45v3.84h-9.29V7.66h9.29z"/></g></g><defs><clipPath id="afdusd__circleClip"><circle cx="16" cy="16" r="13"/></clipPath></defs></svg>`,
};
